import defaultAvatar from "assets/images/userProfile/defaultAvatar.png";
import routes from "config/routes";
import { useMainContext } from "context";
import { getLocalFile } from "helpers/storageFiles";
import Locales from "components/Header/Locales";
import { ReactComponent as LoginIcon } from "assets/images/header/navBar/loginIcon.svg";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { NavLink } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

const NavLinks = ({ close }) => {
  const { t } = useTranslation();
  const { isLoggedIn, user, userLoading, logout } = useMainContext();
  const { id, avatarFileName, firstName } = user || {};
  const clickHandler = () => close(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getLinkClasses = ({ isActive }) =>
    `font-medium text-[13px] whitespace-nowrap transition-colors duration-300 ease-in-out ${
      isActive ? "text-emerald-500" : "text-gray-800 hover:text-emerald-500"
    }`;

  return (
    <nav className="w-full">
      <ul className="flex flex-col lg:flex-row lg:items-center lg:justify-end gap-4 lg:gap-[18px] xl:gap-6 w-full py-4 lg:py-0">
        <li onClick={clickHandler}>
          <NavLink to={routes.home} end className={getLinkClasses}>
            {t("Header.navBar.home")}
          </NavLink>
        </li>
        <li onClick={clickHandler}>
          <NavLink to={routes.aboutUs} className={getLinkClasses}>
            {t("Header.navBar.about")}
          </NavLink>
        </li>
        <li onClick={clickHandler}>
          <NavLink to={routes.socialize} className={getLinkClasses}>
            {t("Header.navBar.socialize")}
          </NavLink>
        </li>
        <li onClick={clickHandler}>
          <NavLink to={routes.news} end className={getLinkClasses}>
            {t("Header.navBar.news")}
          </NavLink>
        </li>
        <li onClick={clickHandler}>
          <NavLink to={routes.healthTopics} className={getLinkClasses}>
            {t("Header.navBar.health")}
          </NavLink>
        </li>
        <li onClick={clickHandler}>
          <NavLink to={routes.materialsAndInstructions} className={getLinkClasses}>
            {t("Header.navBar.materials")}
          </NavLink>
        </li>
        <li onClick={clickHandler}>
          <NavLink to={routes.SHEsurvey} className={getLinkClasses}>
            {t("Header.navBar.assessment")}
          </NavLink>
        </li>

        {/* Desktop Locales placed immediately after headers */}
        <li className="hidden lg:flex items-center ml-4 gap-4">
          <Locales />
          {!isLoggedIn && (
            <NavLink
              to={routes.login}
              className="flex items-center gap-2 bg-[#7ac595] text-white px-5 py-2 rounded-full text-[13px] font-semibold hover:bg-[#6ab384] transition-all whitespace-nowrap shadow-sm ml-2 active:scale-95"
              onClick={clickHandler}
            >
              <LoginIcon className="w-3 h-4 stroke-white" />
              {t("Header.navBar.login")}
            </NavLink>
          )}
        </li>

        {/* User Auth Sections */}
        <li className="flex items-center lg:ml-4 gap-4 mt-2 lg:mt-0">
          {userLoading && (
            <Loader
              color="#FFAB17"
              type="Circles"
              width="20px"
              height="20px"
            />
          )}
          {isLoggedIn && (
            <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                className="flex items-center gap-2 group transition-colors duration-300 hover:text-emerald-500 text-gray-800"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setDropdownOpen(!dropdownOpen);
                }}
              >
                <img
                  src={avatarFileName ? getLocalFile(avatarFileName) : defaultAvatar}
                  alt="Profile Avatar"
                  className="w-8 h-8 rounded-full object-cover border border-gray-200 group-hover:border-emerald-500 transition-colors"
                  style={{ width: "32px", height: "32px" }}
                />
                <p className="font-medium text-[13px] md:text-sm whitespace-nowrap">{firstName}</p>
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-100">
                  <NavLink
                    to={`/user-profile/${id}`}
                    className="block px-4 py-2 text-[13px] md:text-sm text-gray-800 hover:bg-gray-50 hover:text-emerald-500 transition-colors"
                    onClick={() => {
                      setDropdownOpen(false);
                      clickHandler();
                    }}
                  >
                    {t("Header.navBar.profile") !== "Header.navBar.profile" ? t("Header.navBar.profile") : "Профиль"}
                  </NavLink>
                  <button
                    type="button"
                    onClick={() => {
                      setDropdownOpen(false);
                      clickHandler();
                      logout();
                    }}
                    className="block w-full text-left px-4 py-2 text-[13px] md:text-sm text-gray-800 hover:bg-gray-50 hover:text-emerald-500 transition-colors"
                  >
                    {t("UserProfile.logOut")}
                  </button>
                </div>
              )}
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default NavLinks;
